import { IPromoInfo } from '../../../../../types/newbuilding/promoInfo';

export function getImageUrl(promo: IPromoInfo): string {
  if (promo.isFromBank) {
    return promo.bank?.secondSquareImageUrl || '';
  }

  return promo.authorLogoUrl || '';
}
